import { useState, useEffect } from 'react'
import Box from '@mui/joy/Box'
import { CampaignAPI } from '../api/CampaignAPI'
import { FontLoader } from './ui/FontLoader'
import { Interpolator } from './InterpolatorV2'
import { TemplateAPI } from '../api/TemplateAPI'
import { BlobAPI } from '../api/BlobAPI'
import { mapBlogFields } from '../common/utils'

export const CampaignAssetUploader = ({
    campaignId,
    article,
    templates,
    onStatusChanged,
}) => {
    const [fonts, setFonts] = useState(null)
    const [isReady, setIsReady] = useState(false)
    const [detailTemps, setDetailTemps] = useState(null)

    useEffect(() => {
        const templatePromises = templates.map((template) => {
            return TemplateAPI.get(template.id)
        })

        Promise.all(templatePromises).then((responses) => {
            let fonts = []
            let detailedTemplates = []
            responses.map((response) => {
                let template = response.data
                detailedTemplates.push(template)
                let objects = template.canvas.objects
                for (let i = 0; i < objects.length; i++) {
                    const obj = objects[i]
                    if (
                        obj.type === 'template-textbox' ||
                        obj.type === 'textbox' ||
                        obj.type === 'i-text' ||
                        obj.type === 'text'
                    ) {
                        fonts.push({
                            font: obj.fontFamily,
                            weight: obj.fontWeight,
                        })
                    }
                }
            })
            console.log(fonts)
            setDetailTemps(detailedTemplates)
            setFonts(fonts)
        })
    }, [])

    const createAssets = (data) => {
        let assetPromises = data.map(({ canvas, file }) => {
            let objectKey
            return BlobAPI.getPresignedUrl(file.name, file.type)
                .then(({ data: { data: presigned } }) => {
                    objectKey = presigned.fields.key

                    return BlobAPI.uploadBlob(presigned, file)
                })
                .then((uploadResponse) => {
                    const fileUrl = `${uploadResponse.request.responseURL}${objectKey}`
                    return CampaignAPI.createAssetV2(
                        campaignId,
                        fileUrl,
                        canvas
                    )
                })
        })
        Promise.all(assetPromises)
            .then(() => {
                onStatusChanged(true)
            })
            .catch(() => {
                onStatusChanged(false)
            })
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            {fonts && (
                <FontLoader
                    fontDataArr={fonts}
                    onStatusChanged={() => setIsReady(true)}
                />
            )}
            {isReady && (
                <Interpolator
                    varsMap={mapBlogFields(article)}
                    templates={detailTemps}
                    onStatusChanged={createAssets}
                />
            )}
        </Box>
    )
}
